<template>
  <div class="flex flex-col gap-3">
    <SelectLanguages
      v-if="showLanguage"
      v-model="options.language"
      :label="$t('attributes.language')"
      :edition-mode="editionMode"
      customer-language-only
    />

    <div
      v-for="version in versions"
      :key="version.key"
      class="flex flex-row gap-6"
    >
      <div class="shrink-0">
        <WalkmanButton
          v-model="options[version.key]"
          :label="$t(version.label)"
          :options="yesNo"
          :edition-mode="editionMode"
        />
      </div>
      <div v-if="options[version.key]" class="flex-1">
        <BaseShowEditInput
          v-model="options[version.copies]"
          type="number"
          min="1"
          max="10"
          :label="$t('global.nb_copy')"
          :edition-mode="editionMode"
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-3">
      <WalkmanButton
        v-model="options.recto_verso"
        :label="$t('attributes.recto_verso')"
        :options="yesNo"
        :edition-mode="editionMode"
      />
      <WalkmanButton
        v-model="options.page_numbering"
        :label="$t('attributes.page_numbering')"
        :options="yesNo"
        :edition-mode="editionMode"
      />
    </div>

    <SelectComponent
      v-model="options.footer_id"
      :values="footerOptions"
      :label="$t('attributes.invoice_footer')"
      name="footer_id"
      track-by="id"
      display-key="name"
      :edition-mode="editionMode"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WalkmanButton from '@c/WalkmanButton.vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'
import SelectLanguages from '@c/InitialStateFormComponent/Enums/SelectLanguages.vue'
import BaseShowEditInput from '@c/addf-package/components/BaseShowEditInput/BaseShowEditInput.vue'

/**
 * The print options of a commission note, as in the reader of the invoices:
 * used to print and to send the note, and in the printing settings of the
 * agency (`showLanguage` off there: the language depends on the note). The
 * letterhead is chosen apart, in the menu of the print page.
 */
export default {
  name: 'CommissionNotePrintOptions',
  components: {
    BaseShowEditInput,
    SelectComponent,
    SelectLanguages,
    WalkmanButton
  },
  props: {
    modelValue: { type: Object, required: true },
    editionMode: { type: Boolean, default: true },
    showLanguage: { type: Boolean, default: true },
    /** The footers of the note; the predefined ones of the invoices without it (settings) */
    footers: { type: Array, default: null }
  },
  data() {
    return {
      versions: [
        {
          key: 'summary',
          copies: 'nb_summary',
          label: 'invoicing.summary'
        },
        {
          key: 'detailed',
          copies: 'nb_detailed',
          label: 'invoicing.detailed'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({ initialMetadata: 'metadata/getInitialMetadata' }),
    // edited in place, like the print settings of the invoices
    options() {
      return this.modelValue
    },
    yesNo() {
      return [
        { value: true, label: this.$t('enums.yesNo.1') },
        { value: false, label: this.$t('enums.yesNo.0') }
      ]
    },
    footerOptions() {
      return (
        this.footers ?? this.initialMetadata?.enums?.invoicing_footers ?? []
      )
    }
  }
}
</script>
